import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './PrivacyPolicy.css';

const ReturnPolicy = () => {
  const { t } = useLanguage();
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <div className="privacy-header">
          <h1>{t('policy.return.title')}</h1>
          <p className="subtitle">{t('policy.return.subtitle')}</p>
        </div>

        <div className="privacy-content">
          <p className="privacy-intro">
            {t('policy.return.intro')}
          </p>

          <div className="privacy-section">
            <h2>{t('policy.return.s1Title')}</h2>
            <p>
              {t('policy.return.s1Text')}
            </p>
            <ul className="privacy-list">
              <li>{t('policy.return.s1Li1')}</li>
              <li>{t('policy.return.s1Li2')}</li>
              <li>{t('policy.return.s1Li3')}</li>
            </ul>
            <p>{t('policy.return.s1Note')}</p>
          </div>

          <div className="privacy-section">
            <h2>{t('policy.return.s2Title')}</h2>
            <p>
              {t('policy.return.s2Text')}
            </p>
          </div>

          <div className="privacy-section">
            <h2>{t('policy.return.s3Title')}</h2>
            <p>{t('policy.return.s3Text')}</p>
            <ul className="privacy-list">
              <li>{t('policy.return.s3Li1')}</li>
              <li>{t('policy.return.s3Li2')}</li>
              <li>{t('policy.return.s3Li3')}</li>
              <li>{t('policy.return.s3Li4')}</li>
            </ul>
            <p>
              {t('policy.return.s3Note')}
            </p>
          </div>

          <div className="privacy-section">
            <h2>{t('policy.return.s4Title')}</h2>
            <p>
              {t('policy.return.s4Text')}
            </p>
            <ul className="privacy-list warning-list">
              <li>{t('policy.return.s4Li1')}</li>
              <li>{t('policy.return.s4Li2')}</li>
              <li>{t('policy.return.s4Li3')}</li>
            </ul>
          </div>

          <Link to="/" className="back-link">
            {t('policy.backLink')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ReturnPolicy;
